import { Fragment, useEffect, useState } from 'react';
import { Container } from '@/components/container';
import {
    Toolbar,
    ToolbarActions,
    ToolbarDescription,
    ToolbarHeading,
    ToolbarPageTitle,
} from '@/partials/toolbar';
import { PageNavbar } from '@/pages/account';
import { KeenIcon } from '@/components';
import { enqueueSnackbar } from 'notistack';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { FeedbacksContent } from './FeedbacksContent';
import { FeedbackData }  from "@/pages/buddy/types/FeedbackData";

const FeedbacksPage = () => {
    const [feedbacks, setFeedbacks] = useState<FeedbackData[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const { tab } = useParams<{ tab?: string }>();
    const [activePage, setActivePage] = useState<string>(tab || 'overview');

    const API_FEEDBACKS = `${import.meta.env.VITE_APP_API_URL}/admin/feedbacks`;

    const fetchFeedbacks = async () => {
        setLoading(true);
        try {
            const { data } = await axios.get<FeedbackData[]>(API_FEEDBACKS, {
                headers: { Accept: 'application/json' },
            });
            setFeedbacks(data);
        } catch (err) {
            enqueueSnackbar(`Failed to fetch feedbacks: ${err}`, { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFeedbacks();
    }, []);

    return (
        <Fragment>
            <PageNavbar />

            <Container>
                <Toolbar>
                    <ToolbarHeading>
                        <ToolbarPageTitle />
                        <ToolbarDescription>
                            Review and manage all user-submitted feedback. You can view screenshots and delete entries.
                        </ToolbarDescription>
                    </ToolbarHeading>
                </Toolbar>
            </Container>

            <Container>
                <FeedbacksContent
                    feedbacks={feedbacks}
                    loading={loading}
                />
            </Container>
        </Fragment>
    );
};

export { FeedbacksPage };
